export const LOCALIZATION_KEYS = ["button_read_more"];
